import React, { useEffect, useState } from "react"; // <-- import useState
import { useDispatch, useSelector } from "react-redux";
import {
  getOrderStatistics,
  getQrStatusByDate,
} from "../../redux/actions/orderActions";
import DashboardLayout from "./DashboardLayout";
import { useNavigate } from "react-router-dom";
import { fetchDashboardData } from "../../redux/actions/dashboardActions";
import { fetchStateCityStats } from "../../redux/actions/orderActions";
import SortableTable from "../../Pages/Components/SortableTable";
import SearchBar from "../../Pages/Components/SearchBar";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MultiSelectDropdown from "../../Pages/Components/MultiSelectDropdown";
import { FaEye, FaArrowLeft } from "react-icons/fa";

const CouponStat = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(""); // <--- useState here
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const {
    loading = false,
    data: stats = [],
    overall_totals = {},
    error = null,
  } = useSelector((state) => state.orderStatistics || {});
  const [selectedClients, setSelectedClients] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    loading: qrLoading,
    data: qrData,
    error: qrError,
  } = useSelector((state) => state.qrStatusByDate || {});

  const cityStats = useSelector(
    (state) => state.stateCityStats?.data?.city_stats || []
  );
  const stateStats = useSelector(
    (state) => state.stateCityStats?.data?.state_stats || []
  );
  dayjs.extend(customParseFormat);

  const handleViewMore = (date) => {
    const formattedDate = dayjs(date, "DD-MM-YYYY").format("DD-MM-YYYY");
    console.log("Dispatching date:", formattedDate);

    setSelectedDate(formattedDate);
    setIsModalOpen(true);
    dispatch(getQrStatusByDate(formattedDate, userInfo.access_token));
  };
  useEffect(() => {
    if (!userInfo?.access_token) {
      navigate("/login");
    } else {
      dispatch(fetchDashboardData(userInfo.access_token));
      dispatch(getOrderStatistics(userInfo.access_token));
      dispatch(fetchStateCityStats(userInfo.access_token));
    }
  }, [dispatch, userInfo, navigate]);

  // Filter orders by order_id, case insensitive and partial match
  const filteredStats = stats
    ?.filter((order) => {
      const search = searchValue.trim().toLowerCase();
      return (
        order.order_id?.toString().toLowerCase().includes(search) ||
        order.client_name?.toLowerCase().includes(search)
      );
    })

    .filter((order) => {
      const selectedValues = selectedClients?.map((c) => c.value) || [];

      if (selectedValues.length === 0 || selectedValues.includes("All")) {
        return true;
      }

      return selectedValues.includes(order.client_name);
    })

    .filter((order) => {
      if (!startDate && !endDate) return true;

      const rawDate = order.order_date?.trim();

      if (!rawDate) {
        console.warn(
          "Missing or empty order_time for order ID:",
          order.order_id
        );
        return false;
      }

      // Parse DD-MM-YYYY manually to ISO (YYYY-MM-DD)
      const [day, month, year] = rawDate.split("-");
      if (!day || !month || !year) {
        console.warn(
          "Malformed date string:",
          rawDate,
          "for order ID:",
          order.order_id
        );
        return false;
      }

      const formattedDate = `${year}-${month}-${day}`;
      const orderDate = dayjs(formattedDate);

      if (!orderDate.isValid()) {
        console.warn(
          "Parsed invalid date:",
          formattedDate,
          "for order ID:",
          order.order_id
        );
        return false;
      }

      const start = startDate ? dayjs(startDate).startOf("day") : null;
      const end = endDate ? dayjs(endDate).endOf("day") : null;

      if (start && orderDate.isBefore(start)) return false;
      if (end && orderDate.isAfter(end)) return false;

      return true;
    });
  const clientOptions = [
    { value: "All", label: "All" },
    ...Array.from(new Set(stats?.map((o) => o.client_name)))
      .filter(Boolean)
      .map((name) => ({ value: name, label: name })),
  ];

  const columns = [
    { label: "Date", key: "order_date" },
    { label: "Order ID", key: "order_id" },
    { label: "Client Name", key: "client_name" },

    // { label: "Amount", key: "total_amount" },
    { label: "Quantity", key: "total_quantity" },
    { label: "Active", key: "total_active" },
    { label: "InActive", key: "total_inactive" },
    { label: "Expired", key: "total_expired" },
    { label: "Used", key: "total_used" },
    // { label: "Actions", key: "actions" },
  ];

  const renderRow = (row) => (
    <tr
      key={row.order_id}
      className="hover:bg-amber-50 hover:text-gray-950 hover:font-semibold"
    >
      <td className="px-2 py-4 border-b-gray-400">{row.order_date}</td>
      <td className="px-2 py-4 border-b-gray-400">{row.order_id}</td>
      <td className="px-2 py-4 border-b-gray-400">{row.client_name}</td>
      {/* <td className="px-2 py-4 border-b-gray-400">₹{row.total_amount}</td> */}
      <td className="px-2 py-4 border-b-gray-400">{row.total_quantity}</td>
      <td className="px-2 py-4 border-b-gray-400">{row.total_active}</td>
      <td className="px-2 py-4 border-b-gray-400">{row.total_inactive}</td>
      <td className="px-2 py-4 border-b-gray-400">{row.total_expired}</td>
      <td className="px-2 py-4 border-b-gray-400">{row.total_used}</td>
      {/* <td>
        <button
          onClick={() => {
            console.log("Clicked date:", row.order_date);
            handleViewMore(row.order_date);
          }}
        >
          View More
        </button>
      </td> */}
    </tr>
  );

  return (
    <DashboardLayout>
      <div className="bg-priimary max-w-full mx-auto px-2 ">
        <div className="flex items-center space-x-3 py-4">
          <button onClick={() => navigate(-1)} className="hover:text-gray-800">
            <FaArrowLeft size={20} />
          </button>
          <h2 className="text-2xl font-bold text-amber-600 mb-1">
            {" "}
            Coupon Order Statistics
          </h2>
        </div>

        <div className="w-2/3 flex flex-col sm:flex-row items-center justify-start gap-4 mb-4">
          <SearchBar
            className=""
            value={searchValue}
            onChange={setSearchValue}
            placeholder="Search by Order ID / Client "
          />
          <MultiSelectDropdown
            className=""
            options={clientOptions}
            selectedValues={selectedClients}
            setSelectedValues={setSelectedClients}
            placeholder="Filter by Client"
          />

          <DatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => setDateRange(update)}
            isClearable
            placeholderText="Select date range"
            dateFormat="dd MMM yyyy"
            className="w-1.4 px-4 py-2 border border-gray-950 rounded-md text-sm placeholder-gray-950"
          />
        </div>
        {selectedClients.length > 0 && (
          <div className="w-full flex gap-6 mt-2 mb-4">
            {selectedClients.length > 0 && (
              <div className="">
                <div className="text-md font-bold text-gray-950 py-2">
                  Selected Clients:
                </div>
                <div className="flex flex-wrap gap-2">
                  {selectedClients.map((client) => (
                    <span
                      key={client.value}
                      className="bg-amber-300 text-gray-950 px-3 py-2 rounded-full text-sm font-medium"
                    >
                      {client.label}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        {loading ? (
          <p className="text-center text-gray-500">Loading ...</p>
        ) : error ? (
          <p className="text-center text-red-500">{error}</p>
        ) : (
          <div className="overflow-x-auto  rounded">
            <SortableTable
              columns={columns}
              data={filteredStats}
              renderRow={renderRow}
            />
          </div>
        )}
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 shadow-lg max-w-2xl w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">
                QR Redemption Stats ({selectedDate})
              </h3>
              <button
                className="text-gray-500 hover:text-gray-800"
                onClick={() => setIsModalOpen(false)}
              >
                ✕
              </button>
            </div>

            {qrLoading ? (
              <p className="text-gray-600">Loading...</p>
            ) : qrError ? (
              <p className="text-red-500">{qrError}</p>
            ) : qrData ? (
              <>
                <div className="mb-4">
                  <p>
                    <strong>Total Redemptions:</strong>{" "}
                    {qrData.overall_stats.total_redemptions}
                  </p>
                  <p>
                    <strong>Total QR Amount:</strong> ₹
                    {qrData.overall_stats.total_qr_amount}
                  </p>
                  <p>
                    <strong>Unique Customers:</strong>{" "}
                    {qrData.overall_stats.total_unique_customers}
                  </p>
                </div>

                <table className="border border-amber-500 rounded-lg min-w-full bg-white text-sm text-left text-gray-950">
                  <thead className="bg-amber-500 text-xs uppercase text-white">
                    <tr>
                      <th className="py-3 px-4 border-b cursor-pointer select-none">
                        Order ID
                      </th>
                      <th className="py-3 px-4 border-b cursor-pointer select-none">
                        Client Name
                      </th>
                      <th className="py-3 px-4 border-b cursor-pointer select-none">
                        Redemptions
                      </th>
                      <th className="py-3 px-4 border-b cursor-pointer select-none">
                        QR Amount
                      </th>
                      <th className="py-3 px-4 border-b cursor-pointer select-none">
                        Unique Customers
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {qrData.order_wise_stats.map((item) => (
                      <tr key={item.order_id} className="border-t">
                        <td className="px-2 py-4 border-b-gray-400">
                          {item.order_id}
                        </td>
                        <td className="px-2 py-4 border-b-gray-400">
                          {item.client_name}
                        </td>
                        <td className="px-2 py-4 border-b-gray-400">
                          {item.total_redemptions}
                        </td>
                        <td className="px-2 py-4 border-b-gray-400">
                          ₹{item.total_qr_amount}
                        </td>
                        <td className="px-2 py-4 border-b-gray-400">
                          {item.total_unique_customers}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : (
              <p className="font-bold text-md text-center text-gray-950 py-6">
                No data available.
              </p>
            )}
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default CouponStat;
